var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { simpleListCls, simpleListSmallCls } from "./List.less";
function SimpleList(_ref) {
  var _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, type = _ref.type, children = _ref.children, _ref$link = _ref.link, link = _ref$link === void 0 ? null : _ref$link;
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(simpleListCls).concat(type === "small" ? " ".concat(simpleListSmallCls) : "")
  }, title, /* @__PURE__ */ React.createElement("ul", null, children), link);
}
__name(SimpleList, "SimpleList");
export {
  SimpleList
};
